import { mdiAlertCircle, mdiCheckCircle, mdiCloseCircle } from '@mdi/js';
import React from 'react';
import Icon from '@mdi/react';
import { styled } from '@material-ui/styles';
import Typography from '@material-ui/core/Typography';
import { defaultGreen, defaultOrange, defaultRed } from "../../utils/colors";
export var outlinedInputClass = function outlinedInputClass(_ref) {
  var success = _ref.success,
      error = _ref.error,
      warning = _ref.warning;

  if (error) {
    return 'cssOutlinedInputRed';
  }

  if (success) {
    return 'cssOutlinedInputSuccess';
  }

  if (warning) {
    return 'cssOutlinedInputWarning';
  }

  return 'cssOutlinedInput';
};
export var labelClass = function labelClass(_ref2) {
  var success = _ref2.success,
      error = _ref2.error,
      warning = _ref2.warning;

  if (error) {
    return 'cssLabelRed';
  }

  if (success) {
    return 'cssLabelSuccess';
  }

  if (warning) {
    return 'cssLabelWarning';
  }

  return 'cssLabel';
}; // Note: endadornmentmargin is passed as a string because it is added
// as a prop of a <div>, removing the warning on console

var StyledFlexDiv = styled('div')(function (_ref3) {
  var theme = _ref3.theme,
      endadornmentmargin = _ref3.endadornmentmargin;
  return {
    display: 'flex',
    alignItems: 'center',
    boxShadow: 'none !important',
    marginRight: endadornmentmargin === 'true' ? theme.spacing(1) : 0
  };
});
var TypographyStyled = styled(Typography)(function (_ref4) {
  var theme = _ref4.theme;
  return {
    marginLeft: theme.spacing(1 / 3)
  };
});
export function GetEndAdornment(_ref5) {
  var warning = _ref5.warning,
      error = _ref5.error,
      success = _ref5.success,
      endAdornment = _ref5.endAdornment,
      endAdornmentMargin = _ref5.endAdornmentMargin;
  var stateIcon;

  if (error) {
    stateIcon = /*#__PURE__*/React.createElement(Icon, {
      path: mdiCloseCircle,
      color: defaultRed,
      size: 1
    });
  }

  if (success) {
    stateIcon = /*#__PURE__*/React.createElement(Icon, {
      path: mdiCheckCircle,
      color: defaultGreen,
      size: 1
    });
  }

  if (warning) {
    stateIcon = /*#__PURE__*/React.createElement(Icon, {
      path: mdiAlertCircle,
      color: defaultOrange,
      size: 1
    });
  }

  if (stateIcon && endAdornment) {
    return /*#__PURE__*/React.createElement(StyledFlexDiv, {
      endadornmentmargin: endAdornmentMargin.toString()
    }, stateIcon, " ", /*#__PURE__*/React.createElement(TypographyStyled, null, "|"), " ", endAdornment);
  }

  return /*#__PURE__*/React.createElement(StyledFlexDiv, {
    endadornmentmargin: endAdornmentMargin.toString()
  }, stateIcon && stateIcon, endAdornment && endAdornment);
}